import { useCallback } from "react";

import { useFetchAdminAreasByIds } from "@/api/adminArea/userAdminAreaAPI";
import { isAdmAreaFilterImpacted } from "@/helpers/datasetAttributeHelper";

/**
 * Checks whether a dataset's saved ADM area filter still matches its data
 * after the Adm. Area Mapping changed.
 */
export const useAdmAreaFilterImpact = () => {
  const fetchAdminAreasByIds = useFetchAdminAreasByIds();

  return useCallback(
    async (
      areaIds: string[],
      latestAdmAreaLevel: number | null | undefined
    ): Promise<boolean> => {
      if (!areaIds.length) return false;
      // Fetched one by one because one missing area rejects the whole batch
      const areaLevels = await Promise.all(
        areaIds.map((areaId) =>
          fetchAdminAreasByIds([areaId])
            .then(([area]) => area?.level ?? null)
            .catch(() => null)
        )
      );
      return isAdmAreaFilterImpacted(areaLevels, latestAdmAreaLevel);
    },
    [fetchAdminAreasByIds]
  );
};
